module.exports = __webpack_public_path__ + "img/logo-facebook.affa0b30.svg";